import * as Sentry from '@sentry/browser';
import React from 'react';
import { observable, action, runInAction, computed, makeObservable } from 'mobx';

import epaxios from '@/utils/epaxios';

import RootStore from './RootStore';

export default class EulaStore {
  rootStore: typeof RootStore;
  @observable eula = { link: '' };
  @observable eulaFile;
  @observable isLoading = false;
  @observable isReady = false;
  @observable hasEulaAccepted = false;

  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @action get = async () => {
    try {
      this.isLoading = true;
      const { data } = await epaxios.get(`/eula/latest`);
      this.eula = data;

      await fetch(this.eula.link).then(response =>
        response.text().then(text => {
          this.eulaFile = <div dangerouslySetInnerHTML={{ __html: text }} />;
        }),
      );

      runInAction(() => {
        this.isReady = true;
      });
    } catch (e) {
      Sentry.captureException(new Error(`Error when getting Eula page: ${e}`));
    } finally {
      this.isLoading = false;
    }
  };

  @action accept = async payload => {
    try {
      await epaxios.post(`/eula/sign`, payload);
      this.hasEulaAccepted = true;
    } catch (e) {
      return Promise.reject(e);
    }
    return Promise.resolve();
  };

  @computed get hasAccepted() {
    return this.hasEulaAccepted;
  }
}
